<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-scissor`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.583 9.648l-.083.095-14.4 14.4 14.4 14.399a1 1 0 010 1.414l-1.414 1.414a1 1 0 01-1.414 0l-14.4-14.4-5.173 5.173a8 8 0 11-2.828-2.828l5.173-5.173-5.09-5.092a8 8 0 112.794-2.861l5.125 5.124L39.672 6.914a1 1 0 011.32-.083l.094.083L42.5 8.328a1 1 0 01.083 1.32zm-25.376 26.56a4 4 0 10-8 0 4 4 0 008 0zm0-24a4 4 0 10-8 0 4 4 0 008 0z"/></svg>
</template>
<script>

export default {
  name: 'IconScissor',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
